export const COST_INFORMATION = (conversion_rate, currency, volume, mass) => {
  const getPriceConfig = (key, maxValueMultiplier) => ({
    key,
    minValue: 0,
    maxValue:
      maxValueMultiplier !== null
        ? currency === "USD"
          ? maxValueMultiplier
          : maxValueMultiplier * conversion_rate
        : null,
  });
  const waterPriceMaxValue = volume === "kgal" ? 10 * 0.26 : 10;
  const AcidAlkaliPriceMaxValue = mass === "lb" ? 100 * 2.2 : 100;
  const AdditionalChemicalPriceMaxValue = mass === "lb" ? 1 * 2.2 : 1;

  return {
    energyPrice: getPriceConfig("energyPrice", 10),
    waterPrice: getPriceConfig("waterPrice", waterPriceMaxValue),
    costofDownTime: getPriceConfig("downtime_cost", null),
    acidPrice: getPriceConfig("cipAcidPrice", AcidAlkaliPriceMaxValue),
    alkaliPrice: getPriceConfig("cipAlkaliPrice", AcidAlkaliPriceMaxValue),
    // additional_chemical_price: getPriceConfig(
    //   "additional_chemical_price",
    //   AdditionalChemicalPriceMaxValue
    // ),
    cebAcidPrice: getPriceConfig("cebAcidPrice", AcidAlkaliPriceMaxValue),
    cebAlkaliPrice: getPriceConfig("cebAlkaliPrice", AcidAlkaliPriceMaxValue),
    // ceb_additional_chemical_price: getPriceConfig(
    //   "ceb_additional_chemical_price",
    //   AdditionalChemicalPriceMaxValue
    // ),
  };
};
